import { Container, Typography, Grid, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAppStateContext } from '../../../AppStateProvider/AppStateProvider';
import { QualityScore } from '../Quality';
import Excellent from './ExcellentNew.png';
import { ViewIcon } from '../../../../icons/ViewIcon';

const MainContainer = styled('div')({
  display: 'block',
});

const Header = styled(Grid)(({ theme }) => ({
  float: 'left',
  [theme.breakpoints.down('md')]: {
    float: 'initial',
  },
}));

const IllustrationContainer = styled(Grid)(({ theme }) => ({
  float: 'right',
  marginRight: '1em',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    float: 'initial',
    justifyContent: 'center',
    margin: '0 0 2.5em 0',
  },
}));

const Illustration = styled('img')({
  width: '245px',
  height: '200px',
});

const ViewButton = styled(Button)({
  marginTop: '2em',
  '& svg': {
    position: 'relative',
    left: '-5px',
  },
});

const FinishButton = styled(Grid)(({ theme }) => ({
  clear: 'left',
  [theme.breakpoints.down('md')]: {
    clear: 'initial',
    marginBottom: '2em',
  },
}));

interface ExcellentQualityProps {
  quality: QualityScore;
  openModal: () => void;
}

export function ExcellentQuality({ quality, openModal }: ExcellentQualityProps) {
  const { nextPane } = useAppStateContext();

  const qualityScore = quality === QualityScore.Excellent ? 'excellent' : 'good';

  return (
    <Container>
      <MainContainer>
        <Header item lg={5}>
          <Typography variant="h1" gutterBottom>
            Expected quality is {qualityScore}
          </Typography>
        </Header>

        <IllustrationContainer item lg={5}>
          <Illustration src={Excellent} alt="Success" />
          <ViewButton variant="outlined" onClick={openModal}>
            <ViewIcon />
            View detailed quality information
          </ViewButton>
        </IllustrationContainer>

        <FinishButton item lg={5}>
          <Typography variant="body1" gutterBottom>
            This is the last step! Your expected audio and video quality is <strong>{qualityScore}</strong> and overall
            performance looks {qualityScore === 'excellent' ? 'good' : 'ok'}.
          </Typography>

          <Button variant="contained" color="primary" onClick={nextPane}>
            Finish up!
          </Button>
        </FinishButton>
      </MainContainer>
    </Container>
  );
}
